import { useTranslation } from 'react-i18next';

import { ReactComponent as CallIcon } from '@/shared/assets/icons-2.0/call.svg';
import { ReactComponent as TelegramIcon } from '@/shared/assets/icons-2.0/telegram.svg';
import { SUPPORT_PHONE_CALLTO, SUPPORT_PHONE_FORMATTED, TELEGRAM_CHAT_LINK } from '@/shared/constants/dorim.constants';

import { StyledIcon, StyledLink, StyledLinks, StyledRoot, StyledTitle } from './styles';

export type SupportLinksVariant = 'outlined' | 'none';

type SupportLinksProps = {
  linksVariant?: SupportLinksVariant;
};

export const SupportLinks = (props: SupportLinksProps) => {
  const { linksVariant } = props;
  const { t } = useTranslation('auth-page');

  return (
    <StyledRoot>
      <StyledTitle>{t('components.support-link.support')}</StyledTitle>
      <StyledLinks>
        <StyledLink
          linksVariant={linksVariant}
          href={TELEGRAM_CHAT_LINK}
          target="_blank"
          underline="hover"
          color="inherit"
        >
          <StyledIcon>
            <TelegramIcon />
          </StyledIcon>
          {t('Telegram')}
        </StyledLink>
        <StyledLink linksVariant={linksVariant} href={`tel:${SUPPORT_PHONE_CALLTO}`} underline="hover" color="inherit">
          <StyledIcon>
            <CallIcon />
          </StyledIcon>
          {SUPPORT_PHONE_FORMATTED}
        </StyledLink>
      </StyledLinks>
    </StyledRoot>
  );
};
